module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-small-5x10-9c99410aa1c8fa069e08e37ac2a582dd.png";